import { actionTypes} from '../actions/weeklyCryptoRatesHistory'
import createAsyncReducer from './HOCreducer'

export default createAsyncReducer(actionTypes, true, { isActive: true, id: 'to_crypto_currency_id'})
